import React from "react";
import Select from "react-select";

// Renders the per-product "Lock", "All Branches" toggles and the branch
// multi-select used by both the Buy (Cash / Travel Card) and Sell forms.
// `prefix` maps to the formik field names: `${prefix}_lock`,
// `${prefix}_is_all_branches`, `${prefix}_branch_ids`.
const RateBranchFields = ({ formik, branches = [], prefix, label }) => {
  const lockField = `${prefix}_lock`;
  const allField = `${prefix}_is_all_branches`;
  const branchField = `${prefix}_branch_ids`;

  const isAllBranches = Boolean(formik.values?.[allField]);

  // branch_ids may arrive from the API as ids or as objects; normalise to ids.
  const selectedIds = (formik.values?.[branchField] || []).map(
    (v) => v?._id ?? v
  );

  // Server-side validation errors may land on the branch field or on the
  // is_all_branches field. Only surface them after a submit
  // attempt or once the field has been touched, so they don't flash on mount.
  const branchError = formik.errors?.[branchField] || formik.errors?.[allField];
  const showBranchError =
    branchError && (formik.submitCount > 0 || formik.touched?.[branchField]);

  return (
    <>
      <div className="pro-d-flex pro-gap-5 pro-mb-4">
        <div className="pro-toggle">
          <div className="pro-toggle-box">
            <input
              id={lockField}
              name={lockField}
              type="checkbox"
              checked={Boolean(formik.values?.[lockField])}
              onChange={() =>
                formik.setFieldValue(lockField, formik.values?.[lockField] ? 0 : 1)
              }
            />
            <span></span>
          </div>
          <label>{label ? `${label} Lock` : "Lock"}</label>
        </div>

        <div className="pro-toggle">
          <div className="pro-toggle-box">
            <input
              id={allField}
              name={allField}
              type="checkbox"
              checked={isAllBranches}
              onChange={() => {
                const next = formik.values?.[allField] ? 0 : 1;
                formik.setFieldValue(allField, next);
                if (next) {
                  formik.setFieldValue(branchField, []);
                }
              }}
            />
            <span></span>
          </div>
          <label>All Branches</label>
        </div>
      </div>

      {!isAllBranches && (
        <div className="input-wrap pro-mb-5">
          <label className="pro-font-sm pro-mb-1 pro-fw-medium">Branches</label>
          <Select
            id={branchField}
            name={branchField}
            isMulti
            isClearable
            placeholder={"Select Branches"}
            className={`pro-input lg multi-select ${
              showBranchError ? "error" : ""
            }`}
            classNamePrefix="pro-input"
            options={branches}
            getOptionValue={(option) => option?._id}
            getOptionLabel={(option) => option?.name}
            value={branches?.filter((b) => selectedIds.includes(b?._id))}
            onChange={(value) => {
              // clear the server error once the user picks a branch
              formik.setFieldError(branchField, undefined);
              formik.setFieldValue(
                branchField,
                (value || []).map((v) => v?._id)
              );
            }}
          />
          {showBranchError && (
            <span className="error-text">{branchError}</span>
          )}
        </div>
      )}
    </>
  );
};

export default RateBranchFields;
